import React, { useCallback } from 'react';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { FormattedMessage } from 'react-intl';
import { css } from '@emotion/css';
import useNavigateToSpecifiedRoute from '../../hooks/useNavigateToSpecifiedRoute';
import { GET_STARTED_PATH } from '../../config/navigationalRoutes';

const WallpaperContentBlock = () => {
  const { navigateToSpecifiedRoute } = useNavigateToSpecifiedRoute();
  const onGetStartedClick = useCallback(() => {
    navigateToSpecifiedRoute(GET_STARTED_PATH);
  }, [navigateToSpecifiedRoute]);

  return (
    <div className="wallpaperBlockContent">
      <Column alignmentHorizontal="center" backgroundColor="#055D7B">
        <Row
          alignmentHorizontal="center"
          spacingInset="medium large none large">
          <Text color="inverted" type="h400" fontFamily="amazonEmberDisplay">
            <div style={{ color: '#FFFFFF' }}>
              <FormattedMessage id="home_page.wallpaper_content_block.heading" />
            </div>
          </Text>
        </Row>
        <Row alignmentHorizontal="center" spacingInset="none large none large">
          <Text color="inverted" type="b300" fontFamily="amazonEmber">
            <FormattedMessage id="home_page.wallpaper_content_block.content" />
          </Text>
        </Row>
        <Row spacingInset="none large medium large">
          <Button
            onClick={onGetStartedClick}
            className={css`
              &:hover {
                background-color: white;
                color: #055d7b;
              }
            `}>
            <span>
              <FormattedMessage id="home_page.wallpaper_content_block.get_started_button" />
            </span>
          </Button>
        </Row>
      </Column>
    </div>
  );
};

export default WallpaperContentBlock;
